/* ============
 * State of the account module
 * ============
 *
 * The initial state of the account module.
 */

export default {
  id: null,
  email: null,
  name: null,
  screen_name: null,
  country: null,
  lang: null,
  icon_img: null,
  prefecture: null,
  post_code: null,
  address: null,
  street: null,
  stripe_id: null,
  stripe_secret_key: null,
  stripe_pub_key: null
};
